import { render, staticRenderFns } from "./PreOrders.vue?vue&type=template&id=025b6168&scoped=true"
import script from "./PreOrders.vue?vue&type=script&lang=js"
export * from "./PreOrders.vue?vue&type=script&lang=js"
import style0 from "./PreOrders.vue?vue&type=style&index=0&id=025b6168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025b6168",
  null
  
)

export default component.exports